import {
  Box,
  ContextMenu,
  ContextMenuItem,
  ContextMenuList,
  ContextMenuTrigger,
} from '@modusign/design-system';
import { useState } from 'react';

import noop from '@libs/noop';

import RoundButton from './RoundButton';

interface DraftSaveButtonProps {
  disabled?: boolean;
  onSave: () => void;
  onSaveAsNewDraft?: () => void;
}

export default function DraftSaveButton({
  disabled,
  onSave,
  onSaveAsNewDraft,
}: DraftSaveButtonProps) {
  const [contextMenuCanOpened, setContextMenuCanOpened] = useState(false);

  if (onSaveAsNewDraft) {
    return (
      <Box
        sx={{
          '&:hover .DraftSaveButton__contextMenu': {
            visibility: contextMenuCanOpened ? 'visible' : undefined,
          },
        }}
      >
        <ContextMenu isOpen={contextMenuCanOpened} onOpenChange={noop}>
          <ContextMenuTrigger>
            <RoundButton
              disabled={disabled}
              minWidth="94px"
              showIcon
              onMouseEnter={() => {
                setContextMenuCanOpened(true);
              }}
            >
              저장하기
            </RoundButton>
          </ContextMenuTrigger>
          <ContextMenuList
            align="right"
            className="DraftSaveButton__contextMenu"
            data-testid="DraftSaveButton__contextMenu"
            minWidth="150px"
            sx={{
              visibility: 'hidden',
              transform: 'translateX(-56px)',
              transition: 'visibility 0.3s ease-out',
            }}
            top="40px"
            zIndex={500}
          >
            <ContextMenuItem data-testid="save-draft" onClick={onSave}>
              저장하기
            </ContextMenuItem>
            <ContextMenuItem data-testid="save-as-new-draft" onClick={onSaveAsNewDraft}>
              새 서식으로 저장하기
            </ContextMenuItem>
          </ContextMenuList>
        </ContextMenu>
      </Box>
    );
  }

  return (
    <RoundButton disabled={disabled} onClick={onSave}>
      저장하기
    </RoundButton>
  );
}
